<app-page-meta pageTitle="Alternative Investment opportunities in India | Low Risk Investments - finzy"
               tags="peer to peer lending, investment online, manage investments easily, low risk investments, safe investments, alternate investments, high returns, optimise risks, easy investments, p2p lending, investments in India, private money lenders, lending money, online lenders, p2p lender, p2p loans, online lending india, investment opportunities, alternative investments, peer to peer lending India"
               description="Invest with India's premier peer to peer lending platform and get risk optimized returns. P2P lending made easy for lenders. Get the best investment opportunities with Finzy. If you are a P2P lender looking for P2P loans or an alternative investment option, visit today!">
</app-page-meta>

<app-header></app-header>

<div class="page-content">
    <div class="container-fluid">
        <section class="row">
            <div class="col-xs-12 banner-container">
                <div class="campaign-banner">
                    <div class="row banner">
                        <div class="col-lg-offset-1 col-lg-6 left-section">
                            <div class="brand-header">
                                <img id="finzy-logo" alt="finzy logo - Home"
                                     src="../../../assets/images/finzy-logo-white.png" width="150">
                                <img id="nbfc-badge-small-image" src="../../../assets/images/nbfc.png">
                                <div id="nbfc-text">
                                    <div class="title">NBFC-P2P</div>
                                    <div class="subtitle">Registered with RBI</div>
                                </div>
                            </div>
                            <div class="description text-uppercase text-white">
                                <p class="xx-big-text">
                                    An opportunity to invest<br/>in a powerful new asset class
                                </p>
                                <p class="x-big-text pt-16">
                                    Get returns as high as <br/>
                                    <span id="times-2-point-5">2.5&nbsp;</span> <span id="times">Times</span> <br/>
                                    Of fixed deposit
                                </p>
                            </div>
                        </div>

                        <div class="enquire-now-section col-lg-offset-1 col-lg-3">
                            <p class="enquire-now-title">Get in touch</p>
                            <p class="enquire-now-subtitle">Want to know more about how finzy works? Please provide your
                                contact information & we will get in touch with you. </p>

                            <app-enquire-now-form [profileType]=ProfileType.LENDER></app-enquire-now-form>

                            <p class="call-us-enquire-section big-text text-color-grey text-uppercase text-center">Or Call us : <span
                                    class="text-color-finzy-blue">9341 300 300</span></p>
                        </div>

                        <div class="col-lg-1"></div>

                        <a class="col-lg-12 know-more-text"
                           [href]="getCurrentUrl()+'#section-we-are-finzy'">KNOW MORE
                            <br/>
                            <span class="glyphicon glyphicon-chevron-down"></span></a>
                    </div>
                </div>
            </div>
        </section>

        <app-common-invest-sections></app-common-invest-sections>

        <section id="start-investing" class="row start-investing">
            <div class="col-xs-12">
                <div class="row">
                    <div class="col-lg-7 start-investing-description">
                        <h2>Start investing with finzy</h2>
                        <div>Invest with finzy and earn risk optimised returns that are as high as 2.5 times of bank
                            Fixed Deposit on an average
                        </div>
                    </div>
                    <div class="col-lg-3 col-lg-offset-2 start-investing-action">
                        <button class="action-button-secondary" routerLink="/lenderintro"
                                (click)="analyticsTracker.trackButtonClick('Investor campaign', 'INVEST NOW')">Invest Now
                        </button>
                    </div>
                </div>
            </div>
        </section>

        <app-campaign-enquire-footer [profileType]="ProfileType.LENDER"></app-campaign-enquire-footer>
    </div>
</div>
